'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  return typeof Object.entries === 'function' ? Object.entries : implementation;
};